<template>
  <div class="course-info">
    <div class="course-info-box" v-if="!loading">
      <div class="course-box fadeIn" v-if="book">
        <div class="course-top">
          <i class="i-icon banner-cover" :style="{ backgroundImage: 'url(' + book.banner + ')', }"
            v-if="book.banner&&!phoneMode"></i>
          <i class="i-icon course-cover" :style="{ backgroundImage: 'url(' + book.cover + ')', }"
            v-else-if="book.cover"></i>
          <div class="info-box">
            <div class="info-title ellipsis">{{ book.name }}</div>
            <div class="book-other-info">
              <div class="book-subTitle ellipsis" v-if="book.chief_editor_name">
                <svg class="svg-icon">
                  <use xlink:href="#icon-person" />
                </svg>
                <span>{{ book.chief_editor_name }}</span>
              </div>
              <div class="book-subTitle ellipsis" v-if="book.isbn">
                <svg class="svg-icon">
                  <use xlink:href="#icon-tiaoxingma" />
                </svg>
                <span>{{ book.isbn }}</span>
              </div>
              <div class="book-subTitle ellipsis" v-if="book.publisherName">
                <svg class="svg-icon">
                  <use xlink:href="#icon-read" />
                </svg>
                <span>{{ book.publisherName }}</span>
              </div>
            </div>

            <div class="courseprice" v-if="book.is_unique_book">内测版本</div>
            <div class="courseprice" v-else="book.is_unique_book">
              <span :class="{ 'original-price': limitedTimeDiscount }">￥{{ book.price }}</span>
              <span v-if="limitedTimeDiscount" class="discount-price">￥{{ limitedTimeDiscount.discountPrice }}</span>
            </div>
            <div v-if="limitedTimeDiscount" class="discount-info">
              <span class="discount-rate">限时{{ limitedTimeDiscount.discount }}折优惠</span>
              <span class="countdown">{{ limitedTimeDiscount.remainTime }}</span>
            </div>

            <div class="button-box">
              <a-button class="buy-button" type="primary" @click="login()" v-if="!userInfo">请先登录</a-button>
              <a-button class="buy-button" type="primary" @click="routerStudy()" v-else-if="isPaid">进入学习</a-button>
              <template v-else-if="!isPaid">
                <a-button class="buy-button" type="primary" @click="buy()">立即{{ book?.is_unique_book ? "激活" : "购买"
                  }}</a-button>
                <a-button class="buy-button try-read" @click="routerStudy()"
                  v-if="book.trial_chapter?.length > 0">试读</a-button>
              </template>

              <a-button class="buy-button" type="primary" @click="routerStudy()" v-if="book.showExpertReview"
                danger>专家评审入口</a-button>
            </div>
          </div>
        </div>

        <div class="course-menu-box">
          <div class="course-menu">
            <div class="menu-title" :class="{ actived: activeMenu === item }" v-for="item in menuList"
              @click="activeMenu = item">
              {{ item }}
            </div>
          </div>
          <template v-if="activeMenu === '简介'">
            <div class="course-content ck-editor" v-html="book.extension_info?.introduce"
              v-if="book.extension_info?.introduce"></div>
            <div class="empty-box" v-else>
              <img :src="empty_image" alt />
              <div>暂无简介</div>
            </div>
          </template>
          <template v-if="activeMenu === '目录'">
            <div class="catalog" v-if="book.book_info_count?.catalogs">
              <div class="catalog-item" v-for="catalog in book.book_info_count?.catalogs">
                <div class="catalog-part" v-if="catalog.part">{{ catalog.part }}</div>
                <div class="catalog-title">{{ catalog.title }}</div>
                <div class="nav-item" :class="'h' + oitem.level" v-for="oitem in catalog.children">
                  {{ oitem.content }}
                </div>
              </div>
            </div>
            <div class="empty-box" v-else>
              <img :src="empty_image" alt />
              <div>暂无目录</div>
            </div>
          </template>

          <template v-if="activeMenu === '资源'">
            <div class="resources" v-if="book.book_info_count?.resources">
              <div class="resources-item" v-for="item in book.book_info_count?.resources">
                <span class="resources-title">{{ item.title }}：</span>
                <span class="resources-count">{{ item.count }}</span>
              </div>
            </div>
            <div class="empty-box" v-else>
              <img :src="empty_image" alt />
              <div>暂无资源</div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <foot v-if="!userInfo"></foot>
  </div>
</template>

<script>
import navroot from "@/component/public/nav/nav.vue";
import foot from "@/component/public/foot/foot.vue";
import router from "@/router";
import { getSafeRedirectPath } from "@/util/url";
import moment from "moment";

import { mapState } from "vuex";

export default {
  name: "course-info",
  components: {
    navroot,
    foot,
  },
  computed: {
    ...mapState({
      bookUser: 'bookUser',
      userInfo: "userInfo",
      currentStore: "currentStore",
      phoneMode: "phoneMode",
      allStoreBooks: "storeBooks",
    })
  },
  data() {
    return {
      pk_store_book_id: "",

      platformUrl: "",
      empty_image: "https://img.lessonplan.cn/IMG/yuanxi/images/empty.png",
      isPaid: false,
      loading: true,

      book: null,

      activeMenu: "简介",
      menuList: ["简介", "目录", "资源"],
      resourcesTags: [],
      catalog: [],

      idx: 0,
      num: 7,
      showcouser: true,
      alshow: false,

      limitedTimeDiscount: null,
      interDiscountTime: null,
    };
  },
  mounted() {
    window.scrollTo({ top: 0, behavior: "smooth" });
    this.$store.commit("showReturn", true);

    this.pk_store_book_id = this.$route.params.id;

    this.book = this.allStoreBooks.find((item) => item.pk_store_book_id == this.pk_store_book_id);
    if (!this.book) return this.$message.error("未找到教材信息");

    this.loading = false;

    if (this.userInfo) this.findOrder();
    this.setDiscount();
  },
  methods: {
    //登录
    login() {
      this.$router.push({
        path: "/login",
        query: { redirect: getSafeRedirectPath(this.$route.fullPath) },
      });
    },
    //购买
    buy() {
      router.push(`/payment/${this.pk_store_book_id}`);
    },
    //学习
    routerStudy() {
      const {
        pk_store_book_id,
        system_id,
        single_url,
        storeUrl,
        isOtherStore,
      } = this.book;
      let url = `/bookReader/${pk_store_book_id}`;
      if (single_url) {
        url = `${single_url}?pk_store_book_id=${pk_store_book_id}&system_id=${system_id}`;
      }

      if (isOtherStore) {
        url = `${storeUrl}${url}`;
      }
      if (this.$store.state.isElectron) {
        url = `https://yuanxi.online/bookReader/${pk_store_book_id}?pk_store_book_id=${pk_store_book_id}&system_id=${system_id}`;
      }
      window.open(url);
    },
    //跳转
    chooseCourse(item) {
      window.location.href = `/course-info/${item.pk_store_book_id}`;
    },
    //判断是否有购买订单或vip是否过期
    async findOrder() {
      const { system_id, is_unique_book, price } = this.book;
      const res = await this.$api.payorder.findPayOrder({
        system_id,
        fk_userGuid: this.userInfo.PK_UserGuid,
      });
      if (res.statusCode != 200) return this.$message.error(res.error);
      if (res.data && res.data.isPaid) return (this.isPaid = true);

      if (is_unique_book === 1) return;
    },
    async setDiscount() {
      const { pk_store_book_id, limited_time_discount, price } = this.book;
      if (!limited_time_discount) return;
      const { discount } = limited_time_discount;

      const remainSeconds = await this.$api.bookManage.storeBookDiscountTime(pk_store_book_id).then((res) => res.data);
      if (remainSeconds > 0) {
        this.limitedTimeDiscount = {
          discount,
          discountPrice: (price * (discount / 10)).toFixed(2),
          remainSeconds,
          remainTime: `00:00:00`,
        };
        this.limitedTimeDiscount.remainTime = this.setRemainTime();

        this.interDiscountTime = setInterval(() => {
          this.limitedTimeDiscount.remainSeconds--;
          this.limitedTimeDiscount.remainTime = this.setRemainTime();
        }, 1000);
      }
    },

    setRemainTime() {
      const { remainSeconds } = this.limitedTimeDiscount;
      if (remainSeconds <= 0) {
        this.limitedTimeDiscount = null;
        clearInterval(this.interDiscountTime);
        return "00:00:00";
      }

      const duration = moment.duration(remainSeconds, "seconds");
      const days = duration.days();
      const hours = duration.hours().toString().padStart(2, "0");
      const minutes = duration.minutes().toString().padStart(2, "0");
      const seconds = duration.seconds().toString().padStart(2, "0");

      if (days > 0) {
        return `${days}天 ${hours}:${minutes}:${seconds}`;
      }
      return `${hours}:${minutes}:${seconds}`;
    },
  },
  beforeUnmount() {
    if (this.interDiscountTime) clearInterval(this.interDiscountTime);
  },
};
</script>

<style scoped lang="scss">
@import "course-info.scss";
</style>
